/**
 * Collect property which react in Editor tooling
 * @param target - component instance
 * @param propertyKey - property name
 */
export function IDEProp(target, propertyKey) {
  if (!target.constructor.IDEProps) {
    target.constructor.IDEProps = [];
  }
  target.constructor.IDEProps.push(propertyKey);
}

